import type { PropsWithChildren } from "react";
import { createTheme, ThemeProvider } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import Table, { type TableProps } from "@mui/material/Table";
import MuiTableCell, { type TableCellProps } from "@mui/material/TableCell";
import { fontStack } from "src/lib/emotion/utils.ts";
import { useNonConflictingTheme } from "src/lib/emotion/use-non-conflicting-theme.ts";

const muiTheme = createTheme({
  typography: {
    fontFamily: fontStack(["Poppins", "sans-serif"]),
  },
});

/**
 * Таблица MUI со своей темой: в приложении темы MUI нет, и без неё TableCell падает
 * на theme.typography. Тот же приём, что в ArticleDataTable (picking) и GiftItemTable.
 */
export const MuiTable = (props: TableProps) => (
  <MuiThemeProvider theme={muiTheme}>
    <Table {...props} />
  </MuiThemeProvider>
);

/**
 * Ячейка, внутри которой снова действует тема приложения: наши компоненты (Button, Input,
 * TextV2) читают её из emotion, а MuiThemeProvider её подменяет.
 */
export const TableCell = ({
  children,
  ...rest
}: PropsWithChildren<TableCellProps>) => {
  const theme = useNonConflictingTheme();
  return (
    <MuiTableCell {...rest}>
      <ThemeProvider theme={theme}>{children}</ThemeProvider>
    </MuiTableCell>
  );
};
